const LinkedInIcon = () => (
  <svg width={ 20 } height={ 18 } fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.94 2a2 2 0 1 1-4-.002 2 2 0 0 1 4 .002ZM5 5.48H1V18h4V5.48Zm6.32 0H7.34V18h3.94v-6.57c0-3.66 4.77-4 4.77 0V18H20v-7.93c0-6.17-7.06-5.94-8.72-2.91l.04-1.68Z"
      fill="#fff"
    />
  </svg>
);

export default LinkedInIcon;
